import { AxiosResponse } from 'axios';
import { CommonFilterCriteria, PageRequest, PaginationResponseType } from '../types/CommonTypes';
import { PoiData } from '../types/PoiData';
import { API_ADMIN_POI_TEMPLATE } from '../utils/urls';
import { axios, get, post, put } from './baseAxios';

const url = API_ADMIN_POI_TEMPLATE;

export const getById = (id: number): Promise<AxiosResponse<PoiData>> => get(`${url}/${id}`);

export const filter = (
  params: CommonFilterCriteria & PageRequest
): Promise<AxiosResponse<PaginationResponseType<PoiData>>> => get(url, { params: { ...params } });

export const update = (id: number, request: PoiData): Promise<AxiosResponse<PoiData>> =>
  put(`${url}/${id}`, request);

export const create = (request: PoiData): Promise<AxiosResponse<PoiData>> =>
  post(`${url}`, request);

export const deleteById = (id: number): Promise<AxiosResponse<boolean>> =>
  axios.delete(`${url}/${id}`);
